<style>
#modifyLayerStyle .v--modal-box.v--modal {
  min-height: 500px !important;
  min-width: 450px !important;
}
#modifyLayerStyle .verte__menu-origin {
  right: 50px;
}
#modifyLayerStyle .verte__menu-origin--left {
  left: -210px !important;
}
#modifyLayerStyle .verte__controller {
  display: none;
}
#modifyLayerStyle .line-width--input input {
  width: 10px !important;
  text-align: center;
}
#modifyLayerStyle .v-input:not(.unique-input) .v-text-field__slot {
  margin-top: 5px;
}
#modifyLayerStyle > div {
  font-size: 12px !important;
}
#modifyLayerStyle .v-input:not(.unique-input) {
  margin-top: 16px;
  padding-top: 0px;
}

.label--row > .v-list__tile {
  height: 81px !important;
}
.label--row > .v-list__tile > .v-list__tile__content {
  min-width: 100px;
}
</style>

<template>
  <Modal
    modalName="modifyLayerStyle"
    title="Stylizacja warstw"
    @closed="close"
    @opened="getIcons"
    @saved="saveStyle"
    :buttons="[isAdminStylization ? 'save' : '']"
  >
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <v-select
          :items="styleTypes"
          v-model="styleType"
          @change="styleTypeChange"
          style="position:relative;top:3px;"
        ></v-select>
      </v-flex>

      <template v-if="styleType == 'Unikalny'">
        <v-flex xs12>
          <p>
            <b>Wartości domyślne</b>
          </p>
        </v-flex>
        <v-flex xs12>
          <v-list
            subheader
            style="width: 100%"
          >
            <template v-if="editedLayerStyle.geometryType == 'point'">
              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Kolor</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <verte
                    picker="square"
                    model="hex"
                    v-model="editedLayerStyle['circle-color']"
                    @input="styleChange"
                    title="Zmień kolor"
                  ></verte>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Rozmiar punktu</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-text-field
                    v-model.number="editedLayerStyle['circle-radius']"
                    type="number"
                    min="0.1"
                    step="0.1"
                    class="line-width--input"
                    @change="styleChange"
                    @input="styleChange"
                    style="margin-right:-16px;"
                    height="35px"
                  ></v-text-field>
                </v-list-tile-action>
              </v-list-tile>
            </template>
            <template v-if="editedLayerStyle.geometryType == 'line'">
              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Kolor</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <verte
                    picker="square"
                    model="hex"
                    v-model="editedLayerStyle['line-color']"
                    @input="styleChange"
                    title="Zmień kolor"
                  ></verte>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Grubość linii</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-text-field
                    v-model.number="editedLayerStyle['line-width']"
                    type="number"
                    min="1"
                    step="0.1"
                    class="line-width--input"
                    @change="styleChange"
                    @input="styleChange"
                    style="margin-right:-16px;"
                  ></v-text-field>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Styl linii</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-select
                    :items="dashTypes"
                    item-text="name"
                    @change="styleChange"
                    placeholder="Wybierz styl linii"
                    v-model="dashModel"
                    :return-object="true"
                    style="position:relative;top:3px;right:-16px;"
                  ></v-select>
                </v-list-tile-action>
              </v-list-tile>
            </template>
            <template v-if="editedLayerStyle.geometryType == 'polygon'">
              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Kolor wypełnienia</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <verte
                    picker="square"
                    model="hex"
                    v-model="editedLayerStyle['fill-color']"
                    @input="styleChange"
                  ></verte>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Grubość krawędzi</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-text-field
                    v-model.number="editedLayerStyle['line-width']"
                    type="number"
                    min="1"
                    step="0.1"
                    class="line-width--input"
                    @change="styleChange"
                    @input="styleChange"
                    style="margin-right:-16px;"
                  ></v-text-field>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Styl krawędzi</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-select
                    :items="dashTypes"
                    item-text="name"
                    @change="styleChange"
                    placeholder="Wybierz styl krawędzi"
                    v-model="dashModel"
                    :return-object="true"
                    style="position:relative;top:3px;right:-16px;"
                  ></v-select>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Kolor krawędzi</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <verte
                    picker="square"
                    model="hex"
                    v-model="editedLayerStyle['fill-outline-color']"
                    @input="styleChange"
                  ></verte>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Przezroczystość krawędzi</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-text-field
                    v-model.number="editedLayerStyle['fill-outline-opacity']"
                    type="number"
                    min="0"
                    max="1"
                    step="0.1"
                    class="line-width--input"
                    @change="styleChange"
                    @input="styleChange"
                    style="margin-right:-16px;"
                  ></v-text-field>
                </v-list-tile-action>
              </v-list-tile>
            </template>

            <v-list-tile class="list--el">
              <v-list-tile-content>
                <v-list-tile-title>Przezroczystość</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-text-field
                  v-model.number="editedLayerStyle['fill-opacity']"
                  type="number"
                  min="0"
                  max="1"
                  step="0.1"
                  class="line-width--input"
                  @change="styleChange"
                  @input="styleChange"
                  style="margin-right:-16px;"
                ></v-text-field>
              </v-list-tile-action>
            </v-list-tile>

            <v-list-tile class="list--el">
              <v-list-tile-content>
                <v-list-tile-title>Skala widoczności</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-text-field
                  v-model.number="editedLayerStyle['minzoom']"
                  type="number"
                  min="1"
                  step="1"
                  class="line-width--input"
                  @change="styleChange"
                  @input="styleChange"
                  style="margin-right:-16px;"
                ></v-text-field>
              </v-list-tile-action>
            </v-list-tile>

            <v-list-tile class="list--el label--row">
              <v-list-tile-content>
                <v-list-tile-title>Etykieta</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-select
                  v-model="editedLayerStyle.labels"
                  :items="labelsAvailable"
                  attach
                  chips
                  multiple
                  @change="styleChange"
                  placeholder="Wybierz pola"
                  item-text="text"
                  item-value="value"
                  hide-details
                  small-chips
                  deletable-chips
                  :menu-props="{fixed : true, top : true}"
                  style="position:relative;right:-16px;"
                ></v-select>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-flex>
        <v-flex xs12>
          <p>
            <b>Stylizacja po kluczu</b>
          </p>
        </v-flex>
        <v-flex xs12>
          <v-list
            subheader
            style="width: 100%"
          >
            <v-list-tile class="list--el">
              <v-list-tile-content>
                <v-list-tile-title>Klucz</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-select
                  :items="properties"
                  item-text="text"
                  v-model="uniques.property"
                  @change="propertyChange"
                  :return-object="true"
                  style="position:relative;top:3px;right:-16px;"
                ></v-select>
              </v-list-tile-action>
            </v-list-tile>

            <v-list-group
              v-for="(value, key) in uniques.values"
              :key="key"
              v-model="value.active"
              no-action
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ value.text == "" ? `Pusta wartość` : `"${value.text}"` }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Kolor</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <verte
                    picker="square"
                    menuPosition="left"
                    model="hex"
                    v-model="value.color"
                    @input="styleChange"
                    title="Zmień kolor"
                  ></verte>
                </v-list-tile-action>
              </v-list-tile>

              <template v-if="editedLayerStyle.geometryType == 'point'">
                <v-list-tile class="list--el">
                  <v-list-tile-content>
                    <v-list-tile-title>Rozmiar punktu</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-text-field
                      v-model.number="value.radius"
                      type="number"
                      min="0.1"
                      step="0.1"
                      class="line-width--input"
                      @change="styleChange"
                      @input="styleChange"
                      style="margin-right:-16px;"
                      height="35px"
                    ></v-text-field>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
              <template v-if="editedLayerStyle.geometryType == 'line'">
                <v-list-tile class="list--el">
                  <v-list-tile-content>
                    <v-list-tile-title>Grubość linii</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-text-field
                      v-model.number="value.width"
                      type="number"
                      min="1"
                      step="0.1"
                      hide-details
                      single-line
                      class="line-width--input"
                      @change="styleChange"
                      @input="styleChange"
                      style="margin-right:-16px; margin-top: -3px;"
                    ></v-text-field>
                  </v-list-tile-action>
                </v-list-tile>

                <!--<v-list-tile class="list--el">
                  <v-list-tile-content>
                    <v-list-tile-title>Styl linii</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-select
                      :items="dashTypes"
                      item-text="name"
                      @change="styleChange"
                      placeholder="Wybierz styl linii"
                      v-model="editedLayerStyle.dash"
                      :return-object="true"
                      style="position:relative;top:3px;right:-16px;"
                    ></v-select>
                  </v-list-tile-action>
                </v-list-tile>-->
              </template>
              <template v-if="editedLayerStyle.geometryType == 'polygon'"></template>

              <v-list-tile-action style="text-align: right; margin-right: 16px;height: 34px !important;">
                <v-icon
                  medium
                  @click="deleteUniqueValue(key)"
                >delete</v-icon>
              </v-list-tile-action>
            </v-list-group>
          </v-list>
        </v-flex>
        <v-flex
          xs6
          text-xs-right
        >
          <v-btn
            dark
            depressed
            @click="addNewUniqueStyle"
            style="top: 8px;"
          >Dodaj nowy warunek</v-btn>
        </v-flex>
        <v-flex
          xs6
          text-xs-left
          v-if="!!uniques.property"
        >
          <template v-if="!!uniques.property.dictionary">
            <v-select
              class="unique-input"
              v-model="newPropertyValue"
              :items="uniques.property.dictionary"
              label="Wybierz"
              hide-details
              single-line
            ></v-select>
          </template>
          <template v-else>
            <v-text-field
              v-if="uniques.property.type == 'string'"
              type="text"
              class="unique-input"
              clear-icon="clear"
              v-model="newPropertyValue"
              clearable
            ></v-text-field>
            <v-text-field
              v-if="uniques.property.type == 'integer'"
              type="number"
              class="unique-input"
              step="1"
              clear-icon="clear"
              v-model.number="newPropertyValue"
              clearable
            ></v-text-field>
            <v-text-field
              v-if="uniques.property.type == 'real'"
              type="number"
              class="unique-input"
              step="0.01"
              clear-icon="clear"
              v-model.number="newPropertyValue"
              clearable
            ></v-text-field>
            <v-text-field
              v-if="uniques.property.type == 'date'"
              type="date"
              class="date-type unique-input"
              clear-icon="clear"
              prepend-icon="calendar_today"
              v-model="newPropertyValue"
            ></v-text-field>
            <v-text-field
              v-if="uniques.property.type == 'datetime'"
              type="datetime-local"
              class="date-type unique-input"
              v-model="newPropertyValue"
              clear-icon="clear"
              prepend-icon="calendar_today"
            ></v-text-field>
            <v-text-field
              v-if="uniques.property.type == 'time'"
              type="time"
              class="date-type unique-input"
              v-model="newPropertyValue"
              clear-icon="clear"
              prepend-icon="access_time"
            ></v-text-field>
          </template>
        </v-flex>
      </template>
      <template v-else-if="styleType == 'Pojedynczy'">
        <v-flex xs12>
          <v-list
            subheader
            style="width: 100%"
          >
            <template v-if="editedLayerStyle.geometryType == 'point'">
              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Typ wyświetlania</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-select
                    :items="pointTypes"
                    v-model="pointType"
                    @change="styleChange"
                    style="position:relative;top:3px;right:-16px;max-width:120px"
                  ></v-select>
                </v-list-tile-action>
              </v-list-tile>

              <template v-if="pointType == 'Kolor'">
                <v-list-tile class="list--el">
                  <v-list-tile-content>
                    <v-list-tile-title>Kolor</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <verte
                      picker="square"
                      menuPosition="left"
                      model="hex"
                      v-model="editedLayerStyle['circle-color']"
                      @input="styleChange"
                      title="Zmień kolor"
                    ></verte>
                  </v-list-tile-action>
                </v-list-tile>

                <v-list-tile class="list--el">
                  <v-list-tile-content>
                    <v-list-tile-title>Rozmiar punktu</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-text-field
                      v-model.number="editedLayerStyle['circle-radius']"
                      type="number"
                      min="0.1"
                      step="0.1"
                      class="line-width--input"
                      @change="styleChange"
                      @input="styleChange"
                      style="margin-right:-16px;"
                      height="35px"
                    ></v-text-field>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
              <template v-if="pointType == 'Ikona'">
                <v-list-tile class="list--el">
                  <v-list-tile-content>
                    <v-list-tile-title>Rozmiar punktu</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-text-field
                      v-model.number="editedLayerStyle['icon-size']"
                      type="number"
                      min="0.1"
                      step="0.1"
                      class="line-width--input"
                      @change="styleChange"
                      @input="styleChange"
                      style="margin-right:-16px;"
                      height="35px"
                    ></v-text-field>
                  </v-list-tile-action>
                </v-list-tile>

                <v-list-tile class="list--el">
                  <v-list-tile-content>
                    <v-list-tile-title>Aktualna ikona</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <img
                      :src="`${$store.getters.getApiURL}/static/map_icons/${iconsModel}`"
                      style="height: 32px;"
                    >
                  </v-list-tile-action>
                </v-list-tile>
                <v-list-tile class="list--el">
                  <v-list-tile-content>
                    <v-list-tile-title>Lista ikon</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-select
                      :items="icons"
                      placeholder="Wybierz ikonę"
                      v-model="iconsModel"
                      @change="styleChange"
                      style="position:relative;top:3px;right:-16px;max-width:120px"
                    >
                      <template
                        slot="selection"
                        slot-scope="data"
                      >{{data.item.slice(0, -4)}}</template>
                      <template
                        slot="item"
                        slot-scope="data"
                      >
                        <img
                          :src="`${$store.getters.getApiURL}/static/map_icons/${data.item}`"
                          style="height: 25px;"
                        >
                        &nbsp; {{data.item.slice(0, -4)}}
                      </template>
                    </v-select>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </template>
            <template v-if="editedLayerStyle.geometryType == 'line'">
              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Kolor</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <verte
                    picker="square"
                    menuPosition="left"
                    model="hex"
                    v-model="editedLayerStyle['line-color']"
                    @input="styleChange"
                    title="Zmień kolor"
                  ></verte>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Grubość linii</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-text-field
                    v-model.number="editedLayerStyle['line-width']"
                    type="number"
                    min="1"
                    step="0.1"
                    class="line-width--input"
                    @change="styleChange"
                    @input="styleChange"
                    style="margin-right:-16px;"
                  ></v-text-field>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Styl linii</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-select
                    :items="dashTypes"
                    item-text="name"
                    @change="styleChange"
                    placeholder="Wybierz styl linii"
                    v-model="dashModel"
                    :return-object="true"
                    style="position:relative;top:3px;right:-16px;"
                  ></v-select>
                </v-list-tile-action>
              </v-list-tile>
            </template>
            <template v-if="editedLayerStyle.geometryType == 'polygon'">
              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Kolor wypełnienia</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <verte
                    picker="square"
                    menuPosition="left"
                    model="hex"
                    v-model="editedLayerStyle['fill-color']"
                    @input="styleChange"
                  ></verte>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Grubość krawędzi</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-text-field
                    v-model.number="editedLayerStyle['line-width']"
                    type="number"
                    min="1"
                    step="0.1"
                    class="line-width--input"
                    @change="styleChange"
                    @input="styleChange"
                    style="margin-right:-16px;"
                  ></v-text-field>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Styl krawędzi</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-select
                    :items="dashTypes"
                    item-text="name"
                    @change="styleChange"
                    placeholder="Wybierz styl krawędzi"
                    v-model="dashModel"
                    :return-object="true"
                    style="position:relative;top:3px;right:-16px;"
                  ></v-select>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Kolor krawędzi</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <verte
                    picker="square"
                    menuPosition="left"
                    model="hex"
                    v-model="editedLayerStyle['fill-outline-color']"
                    @input="styleChange"
                  ></verte>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Przezroczystość krawędzi</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-text-field
                    v-model.number="editedLayerStyle['fill-outline-opacity']"
                    type="number"
                    min="0"
                    max="1"
                    step="0.1"
                    class="line-width--input"
                    @change="styleChange"
                    @input="styleChange"
                    style="margin-right:-16px;"
                  ></v-text-field>
                </v-list-tile-action>
              </v-list-tile>
            </template>

            <v-list-tile class="list--el">
              <v-list-tile-content>
                <v-list-tile-title>Przezroczystość</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-text-field
                  v-model.number="editedLayerStyle['fill-opacity']"
                  type="number"
                  min="0"
                  max="1"
                  step="0.1"
                  class="line-width--input"
                  @change="styleChange"
                  @input="styleChange"
                  style="margin-right:-16px;"
                ></v-text-field>
              </v-list-tile-action>
            </v-list-tile>

            <v-list-tile class="list--el">
              <v-list-tile-content>
                <v-list-tile-title>Skala widoczności</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-text-field
                  v-model.number="editedLayerStyle['minzoom']"
                  type="number"
                  min="1"
                  step="1"
                  class="line-width--input"
                  @change="styleChange"
                  @input="styleChange"
                  style="margin-right:-16px;"
                ></v-text-field>
              </v-list-tile-action>
            </v-list-tile>

            <v-list-tile class="list--el label--row">
              <v-list-tile-content>
                <v-list-tile-title>Etykieta</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-select
                  v-model="editedLayerStyle.labels"
                  :items="labelsAvailable"
                  attach
                  chips
                  multiple
                  @change="styleChange"
                  placeholder="Wybierz pola"
                  item-text="text"
                  item-value="value"
                  hide-details
                  small-chips
                  deletable-chips
                  :menu-props="{fixed : true, top : true}"
                  style="position:relative;right:-16px;"
                ></v-select>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-flex>
      </template>
    </v-layout>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import Verte from "verte";
import "verte/dist/verte.css";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import debounce from "lodash/debounce";
import get from "lodash/get";
import defaults from "lodash/defaults";
import isEqual from "lodash/isEqual";
import filter from "lodash/filter";
import each from "lodash/each";
import find from "lodash/find";
import map from "lodash/map";
import keyBy from "lodash/keyBy";
import mapValues from "lodash/mapValues";
import flatten from "lodash/flatten";
import groupBy from "lodash/groupBy";
mixin(_, {
  chain,
  get: get,
  defaults,
  debounce,
  isEqual,
  filter,
  each,
  find,
  map,
  keyBy,
  mapValues,
  flatten,
  groupBy,
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    Modal,
    Verte
  },
  data: () => ({
    editedLayerStyle: {},
    editedLayerType: "",
    dashModel: undefined,
    dashTypes: [
      {
        name: "Linia ciągła",
        value: []
      },
      {
        name: "Linia przerywana zwykła",
        value: [10, 40]
      },
      {
        name: "Linia przerywana z kropkami",
        value: [10, 1, 10]
      }
    ],
    icons: [],
    iconsModel: undefined,
    isAdminStylization: false,

    pointTypes: ["Kolor", "Ikona"],
    pointType: "",

    styleTypes: ["Unikalny", "Pojedynczy"],
    styleType: "",

    properties: [],
    newPropertyValue: undefined,

    labelsAvailable: []
  }),
  watch: {
    pointType(_new, _old) {
      if(_old !== "" && _new !== "") {
        this.editStyleDetails();
      }
    }
  },
  methods: {
    saveStyle() {
      this.saveLocalStyle();

      const wodkan = this.currentLayer.layer_type === "water" || this.currentLayer.layer_type === "sewer";
      const userLayer = !!this.currentLayer.table;

      let layer_name;
      let layer_type;
      let keyStyle;
      if(wodkan) {
        layer_name = this.currentLayer.type;
        layer_type = 'layers';
        keyStyle = `layers.${layer_name}`;
      } else if(userLayer) {
        layer_name = this.currentLayer.table;
        layer_type = 'user_layers';
        keyStyle = `user_layers.${layer_name}`;
      }
      const dataStyle = _.get(this.styles, keyStyle);

      if(!layer_name || !layer_type) {
        this.$root.$emit("showSnackbar", "red", `Błedne dane`);
        return;
      }

      const layer_style = JSON.parse(JSON.stringify(dataStyle));
      this.$store.dispatch("setStyle", {
        sid: dataStyle.style_id,
        body: {
          layer_name,
          layer_style,
          layer_type,
        }
      }).then(([status, r]) => {
        if(status) {
          dataStyle.style_id = r;
          this.$store.commit("setSingleStyles", [keyStyle, dataStyle]);
          this.$modal.hide("modifyLayerStyle");
        } else {
          this.$root.$emit("showSnackbar", "red", `${r}`);
        }
      });
    },
    getIcons() {
      this.$store.dispatch("getIcons").then(r => {
        this.icons = r.icons;
      });
    },
    getDicts(table) {
      const self = this;

      self.$root.$emit("showSnackbar", "blue", "Ładowanie słowników");
      return self.$store.dispatch("getDicts").then(r => {
        if(r) {
          self.dicts = _(self.$store.getters.getDicts)
            .map((v) => _.map(v.references, (v2) => ({
              tablename: v2.tablename,
              schema: v2.schema,
              field: v2.field,
              values: v.values
            })))
            .flatten()
            .filter((v) => v.schema === 'aquagis' && v.tablename === table)
            .groupBy('tablename')
            .mapValues((v) => _(v).groupBy('field').mapValues((v2) => v2[0].values).value())
            .value();
          self.dicts = self.dicts[table] || {};
        }
      });

      //przenieść na pojedyńcze pobieranie jak bedzie referencja
      /*self.$store.dispatch("getDictST", {
        schema: 'aquagis',
        table,
      }).then(r => {
        if(r.status === 200) {
          self.dicts = _(r.data)
            .map((v) => _.map(v.references, (v2) => ({
            tablename: v2.tablename,
            field: v2.field,
            values: v.values
          })))
            .flatten()
            .groupBy('tablename')
            .mapValues((v) => _(v).groupBy('field').mapValues((v2) => v2[0].values).value())
            .value();
          self.dicts = self.dicts[table];
        }
      });*/
    },

    toTextIcon(data) {
      return data.slice(0, -4);
    },

    editStyleDetails() {
      this.uniques = {
        property: undefined,
        values: {}
      };

      if(this.styleType === "Pojedynczy") {
        let key = this.editedLayerStyle.geometryType;
        if(
          this.editedLayerStyle.geometryType === "point" &&
          this.pointType === "Ikona"
        ) {
          key = `${key}-icon`;
        }
        this.editedLayerStyle = _.defaults(
          this.editedLayerStyle,
          this.getDefaultStyle(key)
        );
        if(
          this.editedLayerStyle.geometryType === "point" &&
          this.pointType === "Ikona"
        ) {
          this.iconsModel = `${this.editedLayerStyle.externalGraphic}`;
        }

        if(this.editedLayerStyle.geometryType === "line") {
          if(this.editedLayerStyle["line-dash"]) {
            this.dashModel = this.getDashType(this.editedLayerStyle["line-dash"].slice());
          } else {
            this.dashModel = this.dashTypes[0];
          }
        }

      } else if(this.styleType === "Unikalny") {
        this.uniques = {
          property: _.find(this.properties, property =>
            _.isEqual(
              property.value,
              this.editedLayerStyle.uniqueColor.property
            )
          ),
          values: {}
        };
        _.each(this.editedLayerStyle.uniqueColor.stops, value => {
          let data = {
            value: value[0],
            color: value[1],
            active: false
          };

          data.text = value[0] || "";

          this.uniques.values[value[0]] = data;
        });

        if("uniqueWidth" in this.editedLayerStyle) {
          _.each(this.editedLayerStyle.uniqueWidth.stops, value => {
            this.uniques.values[value[0]].width = value[1];
          });
        } else if(this.editedLayerStyle.geometryType === "line") {
          _.each(this.uniques.values, value => {
            value.width = this.editedLayerStyle["line-width"];
          });
        }

        /*if ('uniqueGap' in this.editedLayerStyle) {
          _.each(this.editedLayerStyle.uniqueGap.stops, (value) => {
            this.uniques.values[value[0]].dash = _.find(this.dashTypes, (dash) => _.isEqual(dash.value, value[1]));
          });
        } else if (this.editedLayerStyle.geometryType === "line") {
          _.each(this.uniques.values, (value) => {
            value.dash = _.find(this.dashTypes, (dash) => _.isEqual(dash.value, this.editedLayerStyle['line-dash']));
          });
        }*/

        if("uniqueRadius" in this.editedLayerStyle) {
          _.each(this.editedLayerStyle.uniqueRadius.stops, value => {
            this.uniques.values[value[0]].radius = value[1];
          });
        } else if(this.editedLayerStyle.geometryType === "point") {
          _.each(this.uniques.values, value => {
            value.radius = this.editedLayerStyle["circle-radius"];
          });
        }
      }
    },
    getDefaultStyle(type) {
      switch(type) {
        case "point":
          return {
            "circle-color": "#FFFFFF",
            "fill-opacity": 1,
            "circle-radius": 5,

            "geometryType": "point",
            "minzoom": 5,
          };
        case "point-icon":
          return {
            externalGraphic: this.icons[0],
            "fill-opacity": 1,
            "icon-size": 1,

            "geometryType": "point",
            "minzoom": 5,
          };
        case "line":
          return {
            "line-color": "#FFFFFF",
            "fill-opacity": 1,
            "line-width": 1,
            //"line-dash" : undefined,

            "geometryType": "line",
            "minzoom": 5,
          };
        case "polygon":
          return {
            "fill-color": "#FFFFFF",
            "fill-opacity": 1,
            "line-width": 1,
            "fill-outline-color": "#FFFFFF",
            "fill-outline-opacity": 1,

            "geometryType": "polygon",
            "minzoom": 5,
          };
      }
    },
    getUniqueDefaultStyle(type) {
      switch(type) {
        case "point":
          return {
            color: "#FFFFFF",
            radius: 5
          };
        case "line":
          return {
            color: "#FFFFFF",
            width: 1,
            dash: undefined
          };
        case "polygon":
          return {
            color: "#FFFFFF"
          };
      }
    },
    loadEditedLayer(data) {
      this.currentLayer = data;
      let geometry_type = data.geometry_type;
      if(data.type === "watermeters") {
        //aby można było stylować pojedyńcze pkt wodomierzy
        geometry_type = "point";
      }

      if(data.layer_type === "water") {
        this.editedLayerType = `layers.${data.type}`;
        this.editedLayerStyle = _.get(
          this.styles,
          this.editedLayerType,
          this.getDefaultStyle(geometry_type)
        );
      } else if(data.layer_type === "sewer") {
        this.editedLayerType = data.net_type !== undefined ? `layers.${data.type}.${data.net_type}` : `layers.${data.type}`;
        this.editedLayerStyle = _.get(
          this.styles,
          this.editedLayerType,
          this.getDefaultStyle(geometry_type)
        );
      } else if(data.table) {
        this.editedLayerType = `user_layers.${data.table}`;
        this.editedLayerStyle = _.get(
          this.styles,
          this.editedLayerType,
          this.getDefaultStyle(geometry_type)
        );
      }

      if(geometry_type === "point") {
        this.pointType = this.editedLayerStyle.externalGraphic
          ? "Ikona"
          : "Kolor";
      }

      this.styleType = !!this.editedLayerStyle.uniqueColor
        ? "Unikalny"
        : "Pojedynczy";

      this.properties = _.map(data.fields, field => {
        let dictionary = false;
        if(field.name in this.dicts) {
          dictionary = this.dicts[field.name];
        }

        return {
          text: field.display_name || field.name,
          value: field.name,
          type: field.data_type,
          dictionary,
        };
      });

      this.labelsAvailable = _.map(data.fields, field => ({
        value: field.name,
        text: field.display_name || field.name
      }));

      this.editStyleDetails();
    },
    getDashType(value) {
      return _.find(this.dashTypes, dt => _.isEqual(dt.value, value));
    },

    addNewUniqueStyle() {
      const data = this.getUniqueDefaultStyle(
        this.editedLayerStyle.geometryType
      );
      data.value = this.newPropertyValue;
      if(
        this.uniques.property.type === "integer" ||
        this.uniques.property.type === "real"
      ) {
        data.value = +data.value;
      }
      data.active = false;
      data.text = this.newPropertyValue || "";
      this.uniques.values[this.newPropertyValue] = data;
      this.newPropertyValue = undefined;
      this.$forceUpdate();

      this.styleChange();
    },
    deleteUniqueValue(key) {
      delete this.uniques.values[key];
      this.$forceUpdate();

      this.styleChange();
    },

    changeStylizationType() {
      this.isAdminStylization = true;
    },
    styleTypeChange() {
      if(this.styleType === "Unikalny") {
        //
      } else if(this.styleType === "Pojedynczy") {
        this.uniques = {
          property: undefined,
          values: {}
        };

        //czyszczenie aby się stylizacja nie psuła
        /*_.each(['uniqueColor', 'uniqueWidth', 'uniqueRadius'], key => {
          if (key in this.editedLayerStyle) {
            delete this.editedLayerStyle[key];
          }
        });*/
      }

      this.$forceUpdate();
      this.styleChange();
    },
    propertyChange() {
      this.uniques.values = {};
      this.$forceUpdate();

      this.styleChange();
    },
    getUpdateStyle() {
      const result = _.defaults({}, this.editedLayerStyle);
      delete result.uniqueColor;
      delete result.uniqueWidth;
      delete result.uniqueGap;
      delete result.uniqueRadius;

      if(this.editedLayerStyle.geometryType === "line" && this.dashModel) {
        if("Linia ciągła" === this.dashModel.name) {
          delete result["line-dash"];
        } else {
          result["line-dash"] = this.dashModel.value.slice();
        }
      } else {
        delete result["line-dash"];
      }

      if(this.styleType === "Pojedynczy") {
        if(this.editedLayerStyle.geometryType === "point") {
          if(this.pointType === "Kolor") {
            delete result.externalGraphic;
          } else if(this.pointType === "Ikona") {
            if(this.iconsModel) {
              result.externalGraphic = this.iconsModel;
            }
          }
        } else {
          delete result.externalGraphic;
        }
      } else if(this.styleType === "Unikalny") {
        delete result.externalGraphic;

        const property = _.get(this.uniques, 'property.value');
        result.uniqueColor = {
          property,
          stops: _.map(this.uniques.values, value => [
            value.value,
            value.color
          ]),
          type: "categorical"
        };

        switch(this.editedLayerStyle.geometryType) {
          case "point":
            result.uniqueRadius = {
              property,
              stops: _.map(this.uniques.values, value => [
                value.value,
                value.radius
              ]),
              type: "categorical"
            };
            break;
          case "line":
            result.uniqueWidth = {
              property,
              stops: _.map(this.uniques.values, value => [
                value.value,
                value.width
              ]),
              type: "categorical"
            };
            /*result.uniqueGap = {
              property: this.uniques.property.value,
              stops: _.map(this.uniques.values, (value) => [value.value, value.dash]),
              type: "categorical"
            };*/
            break;
          case "polygon":
            break;
        }
      }

      return result;
    },
    saveLocalStyle() {
      this.$store.commit("setSingleStyles", [this.editedLayerType, this.getUpdateStyle()]);
    },
    styleChange: _.debounce(function (data) {
      this.saveLocalStyle();
    }, 500),

    close() {
      this.editedLayerStyle = {};
      this.editedLayerType = "";
      this.dashModel = undefined;
      this.iconsModel = undefined;
      this.isAdminStylization = false;
      this.pointType = "";
    }
  },
  computed: {
    styles() {
      return this.$store.getters.getStyles;
    }
  },
  created() {
    this.dicts = {};
  },
  mounted() {
    this.getIcons();
    this.$root.$on("modifyLayer", (data) => {
      this.getDicts(data.type).then(() => this.loadEditedLayer(data))
    });
    this.$root.$on("modifyLayerButton", this.changeStylizationType);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/start/modals/ModifyLayerStyle.vue